import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function RegisterRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    const fromAge = Number(searchParams.get("fromAge"));
    const toAge = Number(searchParams.get("toAge"));
    const data = localStorage.getItem("member");

    if (data && id && fromAge && toAge) {
      try {
        const members = JSON.parse(data);
        const validMembers = members.filter(mem => {
          return mem.age <= toAge && mem.age >= fromAge;
        });
        console.log(members)

        const matchedMember = validMembers.reduce((closest, current) => {
          const currentRange = current.toAge - current.fromAge;
          const closestRange = closest.toAge - closest.fromAge;
          return currentRange < closestRange ? current : closest;
        }, validMembers[0]);
        console.log(matchedMember)
        if (matchedMember) {
          const member_id = matchedMember.id || matchedMember.member_id;
          if (member_id) {
            window.location.href = `/parent/course-details/${id}/${member_id}`;
          }
        }
      } catch (err) {
        console.error("Error parsing member data:", err);
      }
    }
  }, [location, navigate]);

  return <div>Redirecting...</div>;
}

export default RegisterRedirect;
